import React from 'react';

import { useField } from 'formik';

import classNames from 'classnames';

import { Input } from '../../../../../Common';

import './index.scss';

const MutateCardTitle = ({ name, ...props }) => {
  const [field, fieldMeta] = useField(name);

  return (
    <Input
      {...props}
      {...field}
      className={classNames(
        'mutate-card-title',
        { 'mutate-card-title-error': fieldMeta.error },
        // eslint-disable-next-line react/destructuring-assignment
        props.className,
      )}
      type="text"
      placeholder="Title"
    />
  );
};

export default MutateCardTitle;
